import React from 'react';
import { IAncillary } from '../../../../domain/ancillary/domain/models/IAncillary';
import { Extra } from '../extra';
import { IAncillaryLevel, NestedInputId } from '../nested-input';

interface ISelectedAncillaryProps {
	ancillary: IAncillary;
	nestedInputLevel: IAncillaryLevel;
}
export const SelectedAncillary = ({
	ancillary,
	nestedInputLevel,
}: ISelectedAncillaryProps) => {
	const extras = ancillary.extras ?? [];

	return (
		<>
			<NestedInputId
				key={ancillary.id}
				level={nestedInputLevel}
				value={ancillary.id}
			/>
			{extras.map((extra, extraIndex) => (
				<Extra
					key={extra.id}
					extra={extra}
					nestedInputLevel={{
						...nestedInputLevel,
						extraIndex,
					}}
				/>
			))}
		</>
	);
};
